import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import StartButtonStyled, { StartButtonWrap } from './StartButton.styled';
import { onStartGame } from '../../../state-actions/onStartGame';
import { onStopGame } from '../../../state-actions/onStopGame';
import { onCountDown } from '../../../state-actions/onCountDown';
import { onCountUp } from '../../../state-actions/onCountUp';

const mapStateToProps = state => ({
  timeOut: state.game.timeOut,
  time: state.game.time,
  roundWin: state.game.roundWin,
  started: state.game.started,
  countDown: state.settings.countDown,
  countUp: state.settings.countUp,
});

const mapDispatchToProps = dispatch => ({
  onStartGame: bool => dispatch(onStartGame(bool)),
  onStopGame: bool => dispatch(onStopGame(bool)),
  onCountDown: num => dispatch(onCountDown(num)),
  onCountUp: num => dispatch(onCountUp(num)),
});

export class StartButton extends Component {
  constructor(props) {
    super(props);
    this.handleStartGame = this.handleStartGame.bind(this);
  }

  // Seemingly, updated props won't reach the inside of a setInterval, so we needed this Component and componentDidUpdate
  componentDidUpdate() {
    const { roundWin, started } = this.props;
    if (roundWin || !started) clearInterval(this.timer);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  handleStartGame() {
    const {
      countUp,
      countDown,
      onStartGame,
      onStopGame,
      onCountDown,
      onCountUp,
      roundWin,
      time,
    } = this.props;

    onStartGame(true);

    let countTime = time;
    let timeTaken = 0;

    this.timer = setInterval(() => {
      countDown && onCountDown((countTime -= 1));
      countUp && onCountUp((timeTaken += 1));

      if (countTime < 1 || roundWin) {
        clearInterval(this.timer);
        onStartGame(false);
        onStopGame(true);
      }
    }, 1000);
  }

  render() {
    const { show } = this.props;
    return (
      <StartButtonWrap className={!show && 'hide'}>
        <StartButtonStyled
          id="start-button"
          onClick={this.handleStartGame}
          {...!show && { disabled: true }}
        >
          Start!
        </StartButtonStyled>
      </StartButtonWrap>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StartButton);

StartButton.propTypes = {
  onStartGame: PropTypes.func,
  onStopGame: PropTypes.func,
  roundWin: PropTypes.bool.isRequired,
  time: PropTypes.number,
  show: PropTypes.bool.isRequired,
};

StartButton.defaultProps = {
  time: 0,
  onStartGame: null,
  onStopGame: null,
};



// WEBPACK FOOTER //
// ./src/components/atoms/StartButton/StartButton.js